/**
 * Deterministic avatar colours from a display name.
 * Keep in sync with foster-lending-app/src/lib/avatarColor.ts
 */

const AVATAR_PALETTE = [
  { backgroundColor: "#C62828", color: "#FFFFFF" },
  { backgroundColor: "#AD1457", color: "#FFFFFF" },
  { backgroundColor: "#6A1B9A", color: "#FFFFFF" },
  { backgroundColor: "#4527A0", color: "#FFFFFF" },
  { backgroundColor: "#283593", color: "#FFFFFF" },
  { backgroundColor: "#1565C0", color: "#FFFFFF" },
  { backgroundColor: "#0277BD", color: "#FFFFFF" },
  { backgroundColor: "#00838F", color: "#FFFFFF" },
  { backgroundColor: "#00695C", color: "#FFFFFF" },
  { backgroundColor: "#2E7D32", color: "#FFFFFF" },
  { backgroundColor: "#558B2F", color: "#FFFFFF" },
  { backgroundColor: "#9E9D24", color: "#1A1A1A" },
  { backgroundColor: "#F9A825", color: "#1A1A1A" },
  { backgroundColor: "#EF6C00", color: "#FFFFFF" },
  { backgroundColor: "#D84315", color: "#FFFFFF" },
  { backgroundColor: "#4E342E", color: "#FFFFFF" },
  { backgroundColor: "#37474F", color: "#FFFFFF" },
  { backgroundColor: "#546E7A", color: "#FFFFFF" },
];

function normalizeAvatarName(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

function hashName(name) {
  const key = normalizeAvatarName(name);
  if (!key) return 0;
  let h = 2166136261;
  for (let i = 0; i < key.length; i++) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function colorFromName(name) {
  return AVATAR_PALETTE[hashName(name) % AVATAR_PALETTE.length];
}

export function avatarStyleFromName(name) {
  return colorFromName(name);
}
